<div class="container-fluid">
  <app-content-tab-list
    activeTab="5"
    type="user"
    category="User Management"
  ></app-content-tab-list>
  <div class="row section1 justify-content-between align-items-center mt-4">
    <div class="col-12 col-md-auto">
      <div class="home-details">
        <h5 class="home-title">User Funding</h5>
        <p class="home-subtitle">
          Attached funding documents for admin verification
        </p>
      </div>
    </div>
  </div>
</div>

<div class="row section1">
  <div class="col-12">
    <div class="users-filters-card">
      <div class="users-filters-title">Filter User Funding</div>
      <div class="users-filters-grid">
        <div class="users-filter-item users-filter-item-wide">
          <label class="users-filter-label">Keyword</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="filters.keyword"
            (keydown)="handleFilterInputKeyDown($event)"
            placeholder="Name, email, year or cause"
          />
        </div>

        <div class="users-filter-item">
          <label class="users-filter-label">Verification</label>
          <select class="form-control" [(ngModel)]="filters.verificationStatus">
            <option value="all">All</option>
            <option value="pending">Pending</option>
            <option value="valid">Valid</option>
            <option value="invalid">Invalid</option>
          </select>
        </div>

        <div class="users-filter-item">
          <label class="users-filter-label">Sort By</label>
          <select class="form-control" [(ngModel)]="filters.sortBy">
            <option value="created_desc">Latest created</option>
            <option value="created_asc">Oldest created</option>
            <option value="year_desc">Year (High-Low)</option>
            <option value="year_asc">Year (Low-High)</option>
          </select>
        </div>

        <div class="users-filter-actions">
          <button
            class="btn users-filter-apply-btn ml-0"
            (click)="applyFilters()"
          >
            Apply Filters
          </button>
          @if (hasActiveFilters()) {
            <button
              class="btn btn-outline-secondary ml-2"
              (click)="clearFilters()"
            >
              Reset
            </button>
          }
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row section1">
  <div class="col-12">
    <div class="table-responsive applicants-details overflow-x-visible">
      <table class="table table-bordered user-table">
        <thead>
          <tr>
            <th scope="col">User</th>
            <th scope="col">Email</th>
            <th scope="col">Year</th>
            <th scope="col">Cause</th>
            <th scope="col">Cause Amount</th>
            <th scope="col">Verification</th>
            <th scope="col">Attachments</th>
            <th scope="col">Created At</th>
          </tr>
        </thead>

        @if (!loading && !!recordsPayload.records?.length) {
          <tbody>
            @for (
              record of recordsPayload.records
                | paginate
                  : {
                      itemsPerPage: perPage,
                      currentPage: recordsPayload.page,
                      totalItems: recordsPayload.total,
                    };
              track record
            ) {
              <tr>
                <td>{{ record?.user?.fullName || "N/A" }}</td>
                <td>{{ record?.user?.email || "N/A" }}</td>
                <td>{{ record?.year || "N/A" }}</td>
                <td [attr.title]="record?.cause || ''">
                  <span class="cause-text">{{ record?.cause || "N/A" }}</span>
                </td>
                <td>
                  {{
                    formatAmount(
                      record?.spentAmount || record?.earmarkedAmount || 0,
                      record?.currency
                    )
                  }}
                </td>
                <td>
                  <span
                    class="verification-pill"
                    [ngClass]="{
                      'is-valid': record?.adminVerificationStatus === 'valid',
                      'is-invalid':
                        record?.adminVerificationStatus === 'invalid',
                      'is-pending':
                        !record?.adminVerificationStatus ||
                        record?.adminVerificationStatus === 'pending',
                    }"
                  >
                    {{ getVerificationLabel(record?.adminVerificationStatus) }}
                  </span>
                </td>
                <td class="attachments-cell">
                  @for (
                    attachment of getAttachments(record);
                    track attachment;
                    let attachmentIndex = $index
                  ) {
                    <div class="attachment-row">
                      <div class="attachment-main">
                        <i [class]="getAttachmentIconClass(attachment)"></i>
                        <div class="attachment-copy">
                          <span
                            class="attachment-name"
                            [attr.title]="attachment?.filename || ''"
                          >
                            {{
                              attachment?.filename ||
                                "Document " + (attachmentIndex + 1)
                            }}
                          </span>
                          <span
                            class="verification-pill attachment-status"
                            [ngClass]="{
                              'is-valid':
                                attachment?.adminVerificationStatus === 'valid',
                              'is-invalid':
                                attachment?.adminVerificationStatus ===
                                'invalid',
                              'is-pending':
                                !attachment?.adminVerificationStatus ||
                                attachment?.adminVerificationStatus ===
                                  'pending',
                            }"
                          >
                            {{
                              getVerificationLabel(
                                attachment?.adminVerificationStatus
                              )
                            }}
                          </span>
                        </div>
                      </div>
                      <div class="attachment-actions">
                        <button
                          class="btn btn-sm btn-outline-primary"
                          (click)="viewDocument(attachment)"
                        >
                          <i class="las la-eye mb-1 align-middle mr-0"></i> View
                        </button>
                        <button
                          class="btn btn-sm btn-outline-success"
                          [disabled]="
                            verificationUpdatingById[
                              getAttachmentUpdateKey(
                                record,
                                attachment,
                                attachmentIndex
                              )
                            ]
                          "
                          (click)="
                            updateVerification(
                              record,
                              'valid',
                              attachment,
                              attachmentIndex
                            )
                          "
                        >
                          <i
                            class="las la-check-circle mb-1 align-middle mr-0"
                          ></i>
                          Valid
                        </button>
                        <button
                          class="btn btn-sm btn-outline-danger"
                          [disabled]="
                            verificationUpdatingById[
                              getAttachmentUpdateKey(
                                record,
                                attachment,
                                attachmentIndex
                              )
                            ]
                          "
                          (click)="
                            updateVerification(
                              record,
                              'invalid',
                              attachment,
                              attachmentIndex
                            )
                          "
                        >
                          <i
                            class="las la-times-circle mb-1 align-middle mr-0"
                          ></i>
                          Invalid
                        </button>
                      </div>
                    </div>
                  }
                </td>
                <td>{{ record?.createdAt | date: "medium" }}</td>
              </tr>
            }
          </tbody>
        }

        @if (loading) {
          <tbody>
            @for (q of loaders; track q) {
              <tr>
                <td>
                  <ngx-skeleton-loader
                    [theme]="{ width: '130px', marginBottom: '0px' }"
                  ></ngx-skeleton-loader>
                </td>
                <td>
                  <ngx-skeleton-loader
                    [theme]="{ width: '180px', marginBottom: '0px' }"
                  ></ngx-skeleton-loader>
                </td>
                <td>
                  <ngx-skeleton-loader
                    [theme]="{ width: '60px', marginBottom: '0px' }"
                  ></ngx-skeleton-loader>
                </td>
                <td>
                  <ngx-skeleton-loader
                    [theme]="{ width: '220px', marginBottom: '0px' }"
                  ></ngx-skeleton-loader>
                </td>
                <td>
                  <ngx-skeleton-loader
                    [theme]="{ width: '120px', marginBottom: '0px' }"
                  ></ngx-skeleton-loader>
                </td>
                <td>
                  <ngx-skeleton-loader
                    [theme]="{ width: '90px', marginBottom: '0px' }"
                  ></ngx-skeleton-loader>
                </td>
                <td>
                  <ngx-skeleton-loader
                    [theme]="{ width: '260px', marginBottom: '0px' }"
                  ></ngx-skeleton-loader>
                </td>
                <td>
                  <ngx-skeleton-loader
                    [theme]="{ width: '180px', marginBottom: '0px' }"
                  ></ngx-skeleton-loader>
                </td>
              </tr>
            }
          </tbody>
        }
      </table>

      @if (!loading && !recordsPayload.records?.length) {
        <div class="d-flex align-items-center justify-content-center py-5">
          No user funding with attachments found
        </div>
      }

      <div class="float-right mt-3">
        <pagination-controls
          (pageChange)="pageChange($event)"
        ></pagination-controls>
      </div>
    </div>
  </div>
</div>
